// TonightsCheckInCard — the priority CTA in Zone B when the day's
// check-in is still pending. Mounts at TodayScreen's `priority ===
// 'checkin'` branch.
//
// Extracted 2026-05-26 from TodayScreen.tsx (lines 1183-1193). Pure
// JSX + a single navigate callback. The visibility predicate
// (priority === 'checkin') and the AnimatePresence wrapper stay in
// TodayScreen — this component is what AnimatePresence cross-fades
// between when the priority changes.

import { Button } from '../ui/Button';
import { Card } from '../ui/Card';

interface TonightsCheckInCardProps {
  /** Fired when the user taps "Start check-in" — parent navigates to /app/checkin. */
  onStart: () => void;
}

export function TonightsCheckInCard({ onStart }: TonightsCheckInCardProps) {
  return (
    <Card accentLeft>
      <h3 className="text-h3" style={{ marginBlockEnd: 'var(--space-2)' }}>
        Tonight&apos;s check-in
      </h3>
      <p className="muted" style={{ marginBlockEnd: 'var(--space-3)' }}>
        Two minutes. How is your body? Sleep, cravings, mood. Sets up tomorrow.
      </p>
      <Button size="lg" block onClick={onStart}>
        Start check-in · ~2 min
      </Button>
    </Card>
  );
}
